import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import Button from "components/base/Button";
import NoDataFound from "components/common/NoDataFound";
import FileListItem from "components/modules/project-management/todo-list/FileListItem";
import axiosInstance from "helpers/api";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

type Inputs = {
  attachment: FileList;
};

const DealDetailsAttachments = ({ attachmentsLv }: any) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<any>();
  const [open, setOpen] = useState(false);
  const [attachmentList, setAttachmentList] = useState([]);
  const [loading, setLoading] = useState(false);
  let { id } = useParams();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("dealAttachment", data.attachment[0]);

    try {
      const response = await axiosInstance.post(
        `/deals/${id}/attachments`,
        formData
      );
      setAttachmentList(response.data.data.attachments);
      toast.success(response.data.message);
      reset();
      setOpen(false);
      setLoading(false);
    } catch (error: any) {
      toast.error(error.response.data.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    setAttachmentList(attachmentsLv);
  }, [attachmentsLv]);

  const handleDeleteAttachment = async (attachmentId: any) => {
    try {
      const response = await axiosInstance.delete(
        `/deals/${id}/attachments/${attachmentId}`
      );
      toast.success(response.data.message);
      setAttachmentList(
        attachmentList.filter(
          (attachment: any) => attachment.id !== attachmentId
        )
      );
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-4">Attachments</h2>
        <Button
          variant="primary"
          onClick={() => setOpen(true)}
          startIcon={<FontAwesomeIcon icon={faPlus} />}
        >
          Add Attachment
        </Button>
      </div>

      <div>
        {attachmentList.length > 0 ? (
          attachmentList.map((attachment: any, index: any) => (
            <FileListItem
              deleteAttachment={handleDeleteAttachment}
              key={index}
              attachment={attachment}
              className={classNames("border-dashed border-translucent", {
                "border-top": index === 0,
                "border-bottom-0": index === attachmentList.length - 1,
              })}
            />
          ))
        ) : (
          <NoDataFound type="Attachments" customClass="mt-lg-10" />
        )}
      </div>
      <Modal
        show={open}
        onHide={() => setOpen(false)}
        className="p-0"
        centered
        contentClassName="border"
      >
        <Modal.Header className="border-translucent p-4">
          <div>
            <h5 className="modal-title text-body-highlight fs-6 lh-sm">
              Add File
            </h5>
            <p className="mb-0 fs-9">Png, Jpg, Pdf, Txt files are allowed.</p>
          </div>

          <Button className="p-1 ms-auto" onClick={() => setOpen(false)}>
            <FontAwesomeIcon icon={faTimes} className="fs-7 text-danger" />
          </Button>
        </Modal.Header>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body className="pt-4 pb-2 px-4">
            <div className="mb-3">
              <Form.Group>
                <Form.Label className="form-label-header mb-2">
                  Topic
                </Form.Label>
                <Form.Control
                  accept=".png, .jpg, .pdf, .txt"
                  type="file"
                  placeholder="Enter Topic"
                  {...register("attachment", {
                    required: "File is required",
                    validate: {
                      lessThan5MB: (files) =>
                        files[0]?.size < 5 * 1024 * 1024 ||
                        "File size should be less than 5MB",
                    },
                  })}
                />
              </Form.Group>
              {errors.attachment && (
                <p style={{ color: "red" }}>
                  {String(errors.attachment.message)}
                </p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-end align-items-center px-4 pb-4 border-0 pt-3">
            <Button
              variant="phoenix-primary"
              size="sm"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              size="sm"
              type="submit"
              className="fs-9 my-0"
              disabled={loading}
            >
              {loading ? "Uploading..." : "Add"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default DealDetailsAttachments;
